module.exports = __webpack_public_path__ + "img/syukyaku-top-013.3b729b0b.jpg";